export const setTimestamp = () => {
    return {
        type: "UPDATE_TIMESTAMP",
        payload: Date.now()
    }
};